import { Network } from '../../../../utils/network'
import { Events } from '../../../../utils/servicesEvents'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function updateTeammate(data, onSuccessEvent, onErrorEvent) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response, Formatter)
  const onDoneEvent = parsedResponse.success ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest(data) {
  const url = `${urls.updateTeammate}${data.id}`

  const headers = {
    Authorization: 'Zmz$muQCQJ6rw1BLQQV2WtT#nP80fzlZef7pXAD69P!C',
  }
  const body = {
    firstName: data.firstName,
    lastName: data.lastName,
    // password: data.password,
    // email: data.email,
    // countryCode: 'BJ',
    metadata: {
      permissions: data.metadata.permissions,
    },
  }
  const response = await Network.sendPostRequestWithHeader(url, headers, body)
  return response
}

function parseResponse(response) {
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    return {
      success: true,
    }
  }
  if (response === null || response.status.code === 409) {
    return {
      success: false,
      emailExists: true,
    }
  }
  if (response === null || response.status.code === 401) {
    return {
      success: false,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { updateTeammate }
